//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from '@/utils/i18n';
export default {
  name: 'fileTypes-editor',
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  data: function data() {
    return {
      uploadFileTypes: [{
        value: 'doc',
        label: 'doc'
      }, {
        value: 'xls',
        label: 'xls'
      }, {
        value: 'docx',
        label: 'docx'
      }, {
        value: 'xlsx',
        label: 'xlsx'
      }]
    };
  }
};